import { useEffect, useState } from "react";
import { clearTaxReturnDraft, readTaxReturnDraft, writeTaxReturnDraft, type TaxReturnDraft } from "@/lib/taxReturnDraft";

export function useTaxReturnDraft(key: string, defaultYear: string, scope: string) {
  const [local, setLocal] = useState<{ scope: string; draft: TaxReturnDraft } | null>(null);
  const localMatches = local?.scope === scope && local.draft.key === key;
  if (local && !localMatches) setLocal(null);
  useEffect(() => {
    // Replacement is final, even if the prior document is displayed again.
    if (key && !readTaxReturnDraft(key)) clearTaxReturnDraft();
  }, [key]);
  // Derive from the exact current key during render, not a later hydration
  // effect: the previous document's text must never appear or be saved.
  const draft = localMatches ? local.draft : readTaxReturnDraft(key);
  const name = draft?.name ?? "";
  const year = draft?.year ?? defaultYear;
  const update = (field: "name" | "year", value: string) => {
    const next = { key, name, year, [field]: value };
    setLocal({ scope, draft: next });
    writeTaxReturnDraft(next);
  };
  const discard = () => {
    clearTaxReturnDraft(key);
    setLocal(null);
  };
  return { name, year, setName: (value: string) => update("name", value),
    setYear: (value: string) => update("year", value), discard };
}
